function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* @indexer:no-export */
import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { injectIntl } from 'react-intl';
function wrapProvided(intl, provided) {
  var desc = intl.formatMessage({
    id: '@dm/components.simple-drop-zone.press-to-lift'
  });
  return Object.assign({}, provided, {
    dragHandleProps: Object.assign({}, provided.dragHandleProps, {
      'aria-label': desc
    })
  });
}
export function DraggableWrapper(_ref) {
  var intl = _ref.intl,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["intl", "children"]);
  return /*#__PURE__*/React.createElement(Draggable, props, function (provided, snapshot) {
    return children(wrapProvided(intl, provided), snapshot);
  });
}
export default injectIntl(DraggableWrapper);